<template>
	<!--pages/result/result.wxml-->
	<div>
		<div class='result-title'>《{{result.name}}》报告</div>
		<div class='result-info'>
			<div>儿童名字：{{children.name}}</div>
			<div>儿童性别：{{children.sex==1?'男':'女'}}</div>
		</div>
		<div class='result-info'>
			<div>出生日期：{{children.birthday}}</div>
			<div>测评时间：{{time}}</div>
		</div>
		<div class='result-info'>
			<div>测评人：{{parentName}}</div>
			<div>关系：{{role}}</div>
		</div>
		<div class='jieshao'>
			<div style='background:#fff;padding:0.20rem;'>
				<div class='jieshao-title'>测评介绍</div>
				<div class='jieshao-desc'>{{result.introduction}}</div>
			</div>
		</div>
		<div class='result-info'></div>
		<div v-for="liss in teshu" v-if="teshu.length!=0">
			<div class="container" style='height:1.55rem;padding:0.30rem;bottom:0'>
				<div class='relative kedu-box' style='background:#FFCBD7;border:none'>
					<div class='kedu-zhu relative'>
						<div class='kedu-zhu-detail' v-bind:style="{right:0,width:liss.bai+'%'}" v-if="liss.bai<50"></div>
						<div class='kedu-zhu-detail' v-bind:style="{left:0,width:liss.bai+'%'}" v-if="liss.bai>=50"></div>
					</div>
					<div class='keudu-xian' style='left:30%'></div>
					<div class='keudu-xian' style='left:40%'></div>
					<div class='keudu-xian' style='left:70%'></div>
					<div class='keudu-xian' style='left:60%'></div>
					<div class='keudu-xi' style='left:10%'></div>
					<div class='keudu-xi' style='left:20%'></div>
					<div class='keudu-xi' style='left:30%'></div>
					<div class='keudu-xi' style='left:40%'></div>
					<div class='keudu-xi' style='left:50%'></div>
					<div class='keudu-xi' style='left:60%'></div>
					<div class='keudu-xi' style='left:70%'></div>
					<div class='keudu-xi' style='left:80%'></div>
					<div class='keudu-xi' style='left:90%'></div>
				</div>
			</div>
			<div class='desc-box' style='padding-bottom:0;margin-bottom:0'>
				<div class='desc-wrapper'>
					<div style='padding-top:0.20rem;margin-bottom:0.10rem;'>
						<div v-for="item in desc" v-if="item.dimension_id==liss.dimension_id" style='margin-bottom:0.40rem;'>
							<div class='desc-title relative' v-for="(items,indexs) in item.explicate">
								<div class='border' v-if="indexs==0"></div>
								<div v-html="items"></div>
							</div>
							<div class='desc-content' v-for="zli in item.dimension_description">{{zli}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container" style='height:4.00rem;padding:0.30rem;bottom:0' v-if="scaleLoad">
			<div class='kedu-title-box'>
				<div class='kedu-desc clearfix'>
					<text class='text2' style='background:#D8EDFF'></text>
					<text class='text1'>超常</text>
				</div>
				<div class='kedu-desc clearfix'>
					<text class='text2' style='background:#EEFED6'></text>
					<text class='text1'>健康</text>
				</div>
				<div class='kedu-desc clearfix'>
					<text class='text2' style='background:#FDF4DC'></text>
					<text class='text1'>危险</text>
				</div>
			</div>
			<div class='relative kedu-box'>
				<div class='zhu' v-bind:style="{height:height+'rem',background:color}"></div>
				<div class='kedu1' style='bottom:0.45rem;'></div>
				<div class='kedu1' style='bottom:2.55rem;'></div>
				<div class='kedu2' style='bottom:0.15rem;'></div>
				<div class='kedu2' style='bottom:1.50rem;'></div>
				<div class='kedu2' style='bottom:2.85rem;'></div>
			</div>
		</div>
		<div class='desc-box' style='padding-bottom:0;margin-bottom:0' v-if="scaleLoad">
			<div class='desc-wrapper'>
				<div style='padding-top:0.20rem;margin-bottom:0.10rem;'>
					<div v-for="item in desc" v-if="item.type==1" style='margin-bottom:0.40rem;'>
						<div class='desc-title relative' v-for="(items,indexs) in item.explicate">
							<div class='border' v-if="indexs==0"></div>
							<div v-html="items"></div>
						</div>
						<div class='desc-content' v-if="item.type==1 && item.dimension_description!=null" v-for="zli in item.dimension_description">{{zli}}</div>
					</div>
				</div>

			</div>

		</div>
		<div class="container" style='height:6.00rem;margin-left:-0.48rem;' v-if="barLoad&& teshu.length==0">
			<div id="barChart" style="width: 100%;height: 100%;margin-top: -20px;"></div>
		</div>
		<div class='desc-box' v-if="barLoad&& teshu.length==0">
			<div class='desc-wrapper'>
				<div style='padding-top:0.20rem;margin-bottom:0.10rem;'>
					<div v-for="item in desc" v-if="item.type==2" style='margin-bottom:0.40rem;'>
						<div class='desc-title relative' v-for="(items,indexs) in item.explicate">
							<div class='border' v-if="indexs==0"></div>
							<!--{{items}}-->
							<div v-html="items"></div>
						</div>
						<div class='desc-content' v-if="item.type==2 && item.dimension_description!=null" v-for="zli in item.dimension_description">{{zli}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container" style='height:5.00rem;margin-left:-0.48rem;' v-if="radarLoad">
			<div id="radarChart" style="width: 100%;height: 100%;margin-top: -20px;"></div>
		</div>
		<div class='desc-box' v-if="radarLoad">
			<div class='desc-wrapper'>
				<div style='padding-top:0.20rem;margin-bottom:0.10rem;'>
					<div v-for="item in desc" v-if="item.type==3" style='margin-bottom:0.40rem;'>
						<div class='desc-title relative' v-for="(items,indexs) in item.explicate">
							<div class='border' v-if="indexs==0"></div>
							<div v-html="items"></div>
						</div>
						<div class='desc-content' v-if="item.type==3 && item.dimension_description!=null" v-for="zli in item.dimension_description">{{zli}}</div>
					</div>
				</div>

			</div>

		</div>
		<div class="container" style='height:5.00rem;width:7.50rem;' v-if="dispersedLoad">
			<div id="dispersedChart" style="width: 100%;height: 100%;margin-top: -20px;"></div>
		</div>
		<div class='desc-box' v-if="dispersedLoad">
			<div class='desc-wrapper'>
				<div style='padding-top:0.20rem;margin-bottom:0.10rem;'>
					<div v-for="item in desc" v-if="item.type==4" style='margin-bottom:0.40rem;'>
						<div class='desc-title relative' v-for="(items,indexs) in item.explicate">
							<div class='border' v-if="indexs==0"></div>
							<div v-html="items"></div>
							<!--{{items}}-->
						</div>
						<div class='desc-content' v-if="item.type==4 && item.dimension_description!=null" v-for="zli in item.dimension_description">{{zli}}</div>
					</div>
				</div>
			</div>

		</div>
		<div style='text-align:center;font-size:0.26rem;color:#F5859D;padding-bottom:0.20rem;padding-top:0.20rem;'>本次测评由景云智心提供技术支持</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				barLoad: true,
				radarLoad: true,
				dispersedLoad: true,
				scaleLoad: false,
				number: '',
				descNum: [],
				result: '',
				children: '',
				teshu: [],
				time: '',
				role: '',
				parentName: '',
				desc: '',
				columnar: "",
				color: '',
				height: '',
				dispersed: '',
				radar: '',
				full_marks:""
			}
		},
		created: function() {
			this.number = searchParam('number');
			var that = this;
			http.get('reports?number=' + this.number).then(function(res) {
				var parent = JSON.parse(localStorage.getItem('user'));
				if(parent.role == 1) {
					var role = '爸爸'
				} else if(parent.role == 2) {
					var role = '妈妈'
				} else if(parent.role == 3) {
					var role = '爷爷'
				} else if(parent.role == 4) {
					var role = '奶奶'
				} else if(parent.role == 5) {
					var role = '姥姥'
				} else if(parent.role == 6) {
					var role = '姥爷'
				}
				that.result = res.data.data.scalar.data;
				that.children = res.data.data.children.data;
				that.time = res.data.data.created_at.split(' ')[0];
				that.role = role,
				that.full_marks = res.data.data.full_marks.data;
				that.parentName = parent.username == null ? '' : parent.username;
				for(var i = 0; i < res.data.data.explicate.data.length; i++) {
					res.data.data.explicate.data[i].explicate = res.data.data.explicate.data[i].explicate.split('@');
					if(res.data.data.explicate.data[i].dimension_description != null) {
						res.data.data.explicate.data[i].dimension_description = res.data.data.explicate.data[i].dimension_description.split('@');
					}
				}
//				that.desc = res.data.data.explicate.data;
				var desc  = res.data.data.explicate.data;
				var _desc = [];
				for(var i=0;i<desc.length;i++){
					for(var j=0;j<desc[i].explicate.length;j++){
						desc[i].explicate[j] = desc[i].explicate[j].replace(/&lt;/g, "<").replace(/&gt;/g, ">");
					}
					_desc.push(desc[i]);
				}
				that.desc = _desc;
				console.log(that.desc)
				if(res.data.data.columnar.data.length != 0) {
					if(res.data.data.scalar.data.id == 22) {
						var columnar = res.data.data.columnar.data;
						var teshu = [];
						var sex = res.data.data.children.data.sex;
						for(var i = 0; i < columnar.length; i++) {
							teshu.push(columnar[i]);
							if(sex == 1) {
								if(columnar[i].dimension == '内外倾向') {
									var full_marks = (teshu[i].score - 5) / (71 - 5);
								} else if(columnar[i].dimension == '情绪稳定性') {
									var full_marks = (teshu[i].score - 33) / (84 - 33);
								} else if(columnar[i].dimension == '倔强性') {
									var full_marks = (teshu[i].score - 35) / (97 - 35);
								} else if(columnar[i].dimension == '自我掩饰性') {
									var full_marks = (teshu[i].score - 13) / (69 - 13);
								}
							} else {
								if(columnar[i].dimension == '内外倾向') {
									var full_marks = (teshu[i].score - 14) / (72 - 14);
								} else if(columnar[i].dimension == '情绪稳定性') {
									var full_marks = (teshu[i].score - 34) / (81 - 34);
								} else if(columnar[i].dimension == '倔强性') {
									var full_marks = (teshu[i].score - 39) / (100 - 39);
								} else if(columnar[i].dimension == '自我掩饰性') {
									var full_marks = (teshu[i].score - 9) / (66 - 9);
								}
							}
							teshu[i].bai = Math.ceil(full_marks * 100);
						}
						that.teshu = teshu;
					} else {
						that.columnar = bubbleSort(res.data.data.columnar.data);
						that.barLoad = true;
						that.barInit();
					}
				} else {
					that.barLoad = false;
				}
				
				if(res.data.data.dispersed.data.length != 0) {
					that.dispersed = bubbleSort(res.data.data.dispersed.data);
					that.dispersedLoad = true;
					that.dispersedInit();
				} else {
					that.dispersedLoad = false;
				}
				
				if(res.data.data.dispersed.data.length != 0) { //离散图
					that.dispersed=bubbleSort(res.data.data.dispersed.data),
					that.dispersedLoad=true,
					that.dispersedInit();
				} else {
						that.dispersedLoad=false
				}
				
				if(res.data.data.radar.data.length != 0) { //雷达图
					that.radar = res.data.data.radar.data,
					that.radarLoad = true;
					that.full_marks = res.data.data.full_marks.data;
					setTimeout(function(){
						that.radarInit();
					},1000)
					
				} else {
					that.radarLoad = false
				}
				if(res.data.data.scale.data.length != 0) { //刻度图
					var data = res.data.data.scale.data;
					var height = parseInt((data[0].score / data[0].full_marks) * 300);
					if(height <= 5) {
						var color = '#FDF4DC';
					} else if(height > 5 && height <= 50) {
						var color = '#EEFED6';
					} else {
						var color = '#D8EDFF';
					}
					that.scaleLoad = true,
					that.height = height,
					that.color = color
				} else {
					that.scaleLoad = false
				}
			})
		},
		methods: {
			radarInit() {
				var charbox = echarts.init(document.getElementById('radarChart'));
				var data = this.radar;
				var desc = [];
				var score = [];
				var pingjun = [];
				for(var i = 0; i < data.length; i++) {
					for(var j = 0; j < this.full_marks.length; j++) {
						if(this.full_marks[j].dimension_id == data[i].dimension_id) {
							desc.push({
								name: data[i].dimension,
								max: this.full_marks[j].full_marks
							})
						}
					}
					score.push(data[i].score)
					pingjun.push(100)
				}
				var option = {
					tooltip: {},
					radar: {
						name: {
							textStyle: {
								color: '#666',
								borderRadius: 3,
								padding: [3, 5],
								backgroundColor: '#FFEEF2'
							}
						},
						splitArea: {
							areaStyle: {
								color: ['rgba(114, 172, 209, 0.0)',
									'rgba(114, 172, 209, 0.0)', 'rgba(114, 172, 209, 0.0)',
									'rgba(114, 172, 209, 0.0)', 'rgba(114, 172, 209, 0.0)', 'rgba(114, 172, 209, 0.0)', 'rgba(114, 172, 209, 0.0)'
								],
								shadowBlur: 10
							}
						},
						indicator: desc
					},
					series: [{
						name: '维度雷达图',
						type: 'radar',

						data: [{
							value: score,
							name: '测评',
							lineStyle: {
								color: '#dcc6a6',
								width: 0
							},
							itemStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: '#ffacbd' // 0% 处的颜色
									}, {
										offset: 1,
										color: '#ffacbd' // 100% 处的颜色
									}],
									globalCoord: false // 缺省为 false
								}
							},
							areaStyle: {
								normal: {
									color: 'rgba(174, 205, 255, 0.56)',
									lineStyle: {
										color: '#dcc6a6',
									}

								}
							},
						}]
					}]
				};
				charbox.setOption(option);
			},
			dispersedInit() {
				var charbox = echarts.init(document.getElementById('dispersedChart'));
				var data = this.dispersed;
				var desc1 = [];
				var score = [];
				for(var i = 0; i < data.length; i++) {
					score.push(data[i].score);
					desc1.push(data[i].dimension)
				}
				var option = {
					tooltip: {},
					xAxis: {
						data: desc1,
						silent: false,
						splitLine: {
							show: false
						},
						axisLabel: {
							interval: 0,
							rotate: 320,
							color: '#666'
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						}
					},
					yAxis: {
						type: 'value',
						splitLine: {
							show: false
						},
						axisLabel: {
							show: false
						},
						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						},
						show: true
					},
					series: [{
						name: '维度',
						type: 'bar',
						data: score,
						animationDelay: function(idx) {
							return idx * 10;
						},
						itemStyle: {
							normal: {
								color: function(params) {
									var colorList = ['rgba(225, 239, 251,1)', 'rgba(225, 248, 251,1)', 'rgba(251, 250, 225,1)', 'rgba(251, 225, 225,1)', 'rgba(227, 225, 251,1)', 'rgba(251, 239, 225,1)', 'rgba(225, 251, 231,1)'];
									return colorList[params.dataIndex];
								},
								borderColor: '#bdccdc'
							},

						},

					}],
					animationEasing: 'elasticOut',
					animationDelayUpdate: function(idx) {
						return idx * 5;
					}
				};
				charbox.setOption(option);
			},
			barInit() {
				var charbox = echarts.init(document.getElementById('barChart'));
				var data = this.columnar;
				var desc1 = [];
				var score = [];
				if(data.length > 7) {
					var dataZoom = [{
						type: 'slider',
						show: true,
						xAxisIndex: [0],
						left: '9%',
						bottom: -5,
						start: 10,
						// end: 90 //初始化滚动条
					}]
				} else {
					var dataZoom = [];
				}
				for(var i = 0; i < data.length; i++) {
					if(data[i].dimension == '其他') {
						continue;
					}
					if(data[i].dimension.length > 2) {
						data[i].dimension = data[i].dimension.substring(0, 2) + '..'
					}
					desc1.push(data[i].dimension);
					score.push(data[i].score);
				}
				var option = {
					xAxis: {
						type: 'category',
						data: desc1,
						splitLine: {
							show: false
						},
						dataZoom: dataZoom,
						axisLabel: {
							interval: 0,
							rotate: 360,
							color: '#666'
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						}
					},
					grid: {
						y: 25,
						x2: 13
					},
					legend: {
						data: score
					},
					yAxis: {
						splitLine: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#999'
							}
						},
						axisTick: { //去掉刻度
							show: false
						},
						show: true,
						axisLabel: {
							formatter: function(value) {
								var texts = [];
								if(value == 30) {

								}
								texts.push('');
								return texts;

							}
						}
					},
					series: [{
						data: score,
						type: 'bar',
						itemStyle: {
							normal: {
								color: function(params) {
									var colorList = ['rgba(225, 239, 251,1)', 'rgba(225, 248, 251,1)', 'rgba(251, 250, 225,1)', 'rgba(251, 225, 225,1)', 'rgba(227, 225, 251,1)', 'rgba(251, 239, 225,1)', 'rgba(225, 251, 231,1)'];
									return colorList[params.dataIndex];
								},
								borderColor: '#bdccdc'
							},

						},
						label: {
							normal: {
								show: false,
								position: 'top',
								textStyle: {
									color: 'black'
								}
							}
						},
						markLine: {
							lineStyle: {
								normal: {
									type: 'dashed'
								}
							},
						}
					}],
					label: {
						normal: {
							show: true,
							position: 'top',
							textStyle: {
								color: 'black'
							}
						}
					},

				};
				charbox.setOption(option);
			}
		},
		components: {},
	}
</script>

<style>
	/* pages/result/result.wxss */
	
	page {
		background: #FFEEF2;
		overflow-x: hidden;
		width: 7.50rem;
	}
	
	.desc-box {
		padding: 0.20rem;
		margin-bottom: 0.20rem;
	}
	
	.desc-title {
		padding-left: 0.20rem;
		line-height: 0.40rem;
		font-size: 0.30rem;
		color: #434343;
		/* font-weight: 700; */
		/* border-left: 4rem solid #F4869D; */
		margin-left: 0.20rem;
	}
	
	.desc-wrapper {
		background: #fff;
		/* min-height: 500rem; */
		padding: 0.20rem 0;
	}
	
	.desc-content {
		padding: 0 0.20rem;
		line-height: 0.40rem;
		color: RGBA(67, 67, 67, 0.43);
		font-size: 0.28rem;
		margin-bottom: 0.20rem;
		margin-top: 0.20rem;
		padding-left: 0.20rem;
		margin-left: 0.20rem;
	}
	
	.kedu-box {
		width: 100%;
		height: 1.55rem;
		border: 1px solid #999;
		border-right: none;
		border-top: none;
	}
	
	.zhu {
		position: absolute;
		left: 50%;
		width: 2.00rem;
		margin-left: -1.00rem;
		border: 1px solid #BDCCDC;
		bottom: 0;
		/* background: #D8EDFF; */
	}
	
	.kedu1 {
		position: absolute;
		left: -0.20rem;
		width: 0.20rem;
		height: 1px;
		background: #9F9F9F;
	}
	
	.kedu2 {
		position: absolute;
		width: 100%;
		border-top: 1px dashed #ccc;
		left: 0;
	}
	
	.relative {
		position: relative;
	}
	
	.kedu-title-box {
		height: 0.70rem;
		display: flex;
		justify-content: space-around;
	}
	
	.kedu-desc {
		line-height: 0.50rem;
		font-size: 0.24rem;
		color: #F5859D;
		font-weight: 700;
		height: 0.50rem;
	}
	
	.kedu-desc .text2 {
		height: 0.28rem;
		width: 0.28rem;
		border: 1rem solid #BDCCDC;
		margin-right: 0.12rem;
		margin-top: 0.11rem;
		float: left;
	}
	td{
		display: block;
	}
	.desc-box-wrapper {
		padding-top: 0.20rem;
		margin-bottom: 0.10rem;
	}
	
	.border {
		position: absolute;
		height: 0.24rem;
		width: 0.08rem;
		background: #F4869D;
		left: 0;
		top: 0.08rem;
	}
	
	.result-title {
		line-height: 0.50rem;
		text-align: center;
		font-size: 0.32rem;
		font-weight: bold;
		color: #333;
		margin-top: 0.20rem;
		margin-bottom: 0.20rem;
	}
	
	.result-info {
		padding: 0 0.26rem;
		line-height: 0.45rem;
		font-size: 0.28rem;
		/* font-weight: 700; */
		display: flex;
		justify-content: space-between;
	}
	
	.result-info view {
		width: 50%;
		text-align: left;
	}
	
	.jieshao {
		padding: 0.20rem 0.20rem;
		/* background: #fff; */
	}
	
	.jieshao-title {
		line-height: 0.60rem;
		font-size: 0.32rem;
		font-weight: bold;
		color: #333;
	}
	
	.jieshao-desc {
		line-height: 0.50rem;
		font-size: 0.28rem;
		color: #333;
	}
	
	.kedu-zhu {
		position: absolute;
		height: 0.75rem;
		background: rgba(238, 238, 238, 0.5);
		top: 0.40rem;
		left: 0;
		width: 100%;
	}
	
	.keudu-xian {
		position: absolute;
		left: 0.20rem;
		height: 1.55rem;
		width: 1px;
		border-left: 1px dashed #fff;
	}
	
	.kedu-zhu-detail {
		position: absolute;
		width: 50%;
		height: 100%;
		box-sizing: border-box;
		background: #B2CFFF;
	}
	
	.keudu-xi {
		position: absolute;
		bottom: 0;
		height: 0.12rem;
		width: 1px;
		border-left: 1px solid #fff;
	}
</style>


// WEBPACK FOOTER //
// src/pages/result.vue